__turbopack_context__.v({
  "formModal": "FormModal-module-scss-module__ieZTiq__formModal",
  "formModalBack": "FormModal-module-scss-module__ieZTiq__formModalBack",
  "formModalBtnClose": "FormModal-module-scss-module__ieZTiq__formModalBtnClose",
  "formModalContainer": "FormModal-module-scss-module__ieZTiq__formModalContainer",
  "formModalTitle": "FormModal-module-scss-module__ieZTiq__formModalTitle",
});
